import React from 'react';
export function Testimoniale() {
  const testimoniale = [{
    autor: 'Mela',
    poza: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400&q=80',
    citat: 'Vreau să încep prin a spune că sunt foarte recunoscătoare pentru faptul că am avut ocazia să lucrăm împreună. Fiecare întâlnire pe care am avut-o cu tine a fost o oportunitate de a-mi explora gândurile și emoțiile într-un mod sigur și încurajator. M-ai ajutat să descopăr perspective noi și să îmi dezvolt abilitățile de a face față provocărilor. Am descoperit lucruri noi despre mine și am învățat să îmi gestionez emoțiile în momentele în care nu eram în zona mea de confort. Apreciez foarte mult empatia și profesionalismul tău. Mă simt mai încrezătoare datorită sprijinului tău constant. Mulțumesc din suflet pentru tot!'
  }, {
    autor: 'Alina Nicoleta',
    poza: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=400&q=80',
    citat: 'Vreau să te felicit, Teo. Îmi place că ai o voce caldă și liniștită, inspiri siguranță.'
  }, {
    autor: 'Marina-Georgiana Burz',
    poza: 'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=400&q=80',
    citat: 'Apreciez foarte mult aceste workshop-uri pe care le faceți. Sunt interactive, motivaționale și educative. Cu siguranță multe persoane se simt ascultate acum, deși unii nu sunt ascultați în viața lor de zi cu zi. Vă felicit!'
  }, {
    autor: 'Loredana Coderie',
    poza: 'https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?w=400&q=80',
    citat: 'Vă mulțumesc frumos! A fost cu adevărat deosebit și inspirațional. Așteptăm cu drag șansa de a participa și la alte evenimente similare.'
  }];
  return <main className="flex-grow bg-rise-white" data-id="element-1175">
      {/* SECTION 1 — HERO */}
      <section className="py-12 md:py-20 px-6 overflow-hidden" data-id="element-1176">
        <div className="max-w-rise-content mx-auto flex justify-center" data-id="element-1177">
          {/* Text Content */}
          <div className="flex flex-col items-center text-center max-w-3xl" data-id="element-1178">
            <span className="inline-block font-dm-sans text-[13px] tracking-[0.15em] uppercase text-rise-black border border-rise-gold/50 rounded-full px-5 py-2 mb-6" data-id="element-1179">
              TESTIMONIALE
            </span>
            <h1 className="font-playfair text-[36px] md:text-[52px] text-rise-black leading-tight mb-6" data-id="element-1180">
              Poveștile celor care au lucrat cu mine
            </h1>
            <p className="font-playfair italic text-rise-gold text-[24px] md:text-[32px] mb-8" data-id="element-1181">
              Schimbări reale, în cuvintele lor
            </p>
            <p className="font-dm-sans text-[19px] text-rise-gray max-w-xl mx-auto leading-relaxed" data-id="element-1182">
              Mai jos găsești mărturii sincere de la oameni care au ales să-și
              ofere șansa unei conversații, a unui workshop sau a unui proces de
              creștere alături de mine.
            </p>
          </div>
        </div>
      </section>

      {/* SECTION 2 — TESTIMONIALS GRID */}
      <section className="py-12 md:py-20 px-6" data-id="element-1183">
        <div className="max-w-rise-content mx-auto" data-id="element-1184">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-1185">
            {testimoniale.map((testimonial, index) => <div key={index} className="bg-white p-8 md:p-[40px] rounded-xl border border-gray-200 shadow-sm flex flex-col" data-id="element-1186">
                {/* Author Photo with branded frame */}
                <div className="relative w-[160px] mx-auto mb-8" data-id="element-1187">
                  {/* Corner bracket accents — top right */}
                  <svg className="absolute -top-3 -right-3 w-10 h-10 text-rise-gold pointer-events-none z-20" viewBox="0 0 50 50" fill="none" stroke="currentColor" strokeWidth="1.5" data-id="element-1188">
                    <path d="M50 0 L50 15 M50 0 L35 0" data-id="element-1189" />
                  </svg>
                  {/* Corner bracket accents — bottom left */}
                  <svg className="absolute -bottom-3 -left-3 w-10 h-10 text-rise-gold pointer-events-none z-20" viewBox="0 0 50 50" fill="none" stroke="currentColor" strokeWidth="1.5" data-id="element-1190">
                    <path d="M0 50 L0 35 M0 50 L15 50" data-id="element-1191" />
                  </svg>
                  <img src={testimonial.poza} alt={testimonial.autor} className="w-full aspect-square object-cover rounded-xl shadow-md relative z-10 ring-1 ring-rise-gold/30" data-id="element-1192" />
                </div>

                <div className="text-rise-gold mb-6" data-id="element-1193">
                  <svg width="32" height="24" viewBox="0 0 32 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" data-id="element-1194">
                    <path d="M13.4667 13.6C13.4667 19.4667 9.2 24 3.86667 24C1.73333 24 0 22.2667 0 20.1333C0 18 1.73333 16.2667 3.86667 16.2667C4.66667 16.2667 5.33333 16.5333 6 16.9333C6.4 15.6 6.66667 14.1333 6.66667 12.6667C6.66667 8.53333 4.26667 4.93333 0.666667 3.2L3.33333 0C8.93333 2.53333 13.4667 7.73333 13.4667 13.6ZM32 13.6C32 19.4667 27.7333 24 22.4 24C20.2667 24 18.5333 22.2667 18.5333 20.1333C18.5333 18 20.2667 16.2667 22.4 16.2667C23.2 16.2667 23.8667 16.5333 24.5333 16.9333C24.9333 15.6 25.2 14.1333 25.2 12.6667C25.2 8.53333 22.8 4.93333 19.2 3.2L21.8667 0C27.4667 2.53333 32 7.73333 32 13.6Z" data-id="element-1195" />
                  </svg>
                </div>
                <p className="font-dm-sans text-[19px] text-rise-gray leading-relaxed mb-8 flex-grow italic" data-id="element-1196">
                  "{testimonial.citat}"
                </p>
                <div className="font-dm-sans font-semibold text-[15px] text-rise-gold" data-id="element-1197">
                  {testimonial.autor}
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* SECTION 3 — CTA */}
      <section className="py-14 md:py-24 bg-rise-black text-center relative overflow-hidden px-6" data-id="element-1198">
        {/* Subtle background decoration */}
        <div className="absolute inset-0 opacity-10 pointer-events-none flex items-center justify-center" data-id="element-1199">
          <div className="w-[800px] h-[800px] border-[1px] border-rise-gold rounded-full" data-id="element-1200"></div>
          <div className="absolute w-[600px] h-[600px] border-[1px] border-rise-gold rounded-full" data-id="element-1201"></div>
          <div className="absolute w-[400px] h-[400px] border-[1px] border-rise-gold rounded-full" data-id="element-1202"></div>
        </div>

        <div className="max-w-rise-content mx-auto relative z-10" data-id="element-1203">
          <h2 className="font-playfair text-[32px] md:text-[48px] text-rise-white mb-6" data-id="element-1204">
            Vrei să fii următoarea noastră poveste de succes?
          </h2>
          <p className="font-dm-sans text-[19px] text-rise-white/80 mb-8 max-w-2xl mx-auto leading-relaxed" data-id="element-1205">
            Începe cu o sesiune cadou 1:1, gratuită, fără presiune. Plecăm de la
            situația ta reală și descoperim împreună un prim pas concret.
          </p>
          <p className="font-playfair italic text-rise-gold text-[22px] md:text-[26px] mb-12" data-id="element-1206">
            Schimbarea începe cu o conversație.
          </p>
          <div className="flex justify-center" data-id="element-1207">
            <a href="https://comunitatearise.ro/sesiune1la1" target="_top" className="bg-rise-gold text-rise-black hover:bg-rise-gold-light px-8 py-4 rounded-xl font-dm-sans font-semibold text-[16px] transition-colors inline-flex items-center justify-center" data-id="element-1208">
              Rezervă Sesiunea Cadou 1:1
            </a>
          </div>
        </div>
      </section>
    </main>;
}